import { render } from "./new-roles.vue?vue&type=template&id=1ce86c5c&lang=pug"
import script from "./new-roles.vue?vue&type=script&lang=js"
export * from "./new-roles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__